import classNames from "classnames";
import Image from "next/image";
import { Inter } from "next/font/google";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";

const inter = Inter({ subsets: ["latin"] });

export const GlutenFreePlaceRecommendations = ({ count }) => {
    const avatars = new Array(count > 3 ? 3 : count).fill(null);
    
    return (
        <div className="flex flex-col gap-2">
            <div
                onClick={() => trackItemTapped(MixpanelValues.ItemTapped.GLUTEN_FREE_REC_COUNT)}
                className="flex items-center gap-2">
                <div
                    style={{
                        width: avatars.length > 0 && `${(avatars.length - 1) * 12 + 20}px`,
                    }}
                    className={classNames({
                        "w-[68px] h-5": true,
                        "w-auto flex justify-center items-center relative": count > 0,
                    })}>
                    {avatars.map((_, index) => (
                        <div
                            className="size-5 absolute"
                            style={{ left: `${index * 12}px` }}
                            key={index}>
                            <Image
                                src={`/assets/avatars/Avatar user-${index + 1}.png`}
                                alt="Gluten Free Users"
                                width={20}
                                height={20}
                                className={classNames({
                                    "ring-white": true,
                                    "size-5 ring-1 rounded-full": true,
                                })}
                                style={{ objectFit: "contain" }}
                            />
                        </div>
                    ))}
                </div>
                <label
                    className={classNames(inter.className, {
                        "font-semibold": true,
                        "text-[13px] font-medium": true,
                        "text-blue-900": true,
                    })}>
                    {count} recommendation{`${count > 1 ? "s" : ""}`} for gluten-free
                </label>
            </div>
            <div
                onClick={() => trackItemTapped(MixpanelValues.ItemTapped.LEARN_MORE)}
                className="h-10 px-3 py-2 bg-[#002551] rounded-xl border border-[#002551] justify-center items-center gap-2 inline-flex">
                <div className="justify-center items-center gap-1 flex">
                    <div
                        className={classNames(inter.className, {
                            "text-center text-white text-[15px] font-medium leading-snug": true,
                        })}>
                        Learn more
                    </div>
                </div>
            </div>
        </div>
    );
};
